import SimpleQuestion from "./SimpleQuestion";
import PropTypes from "prop-types";
import { PatternFormat } from "react-number-format";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useState } from "react";

const ContactNumber = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      rightComponent={
        <ContactNumberInput
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></ContactNumberInput>
      }
    ></SimpleQuestion>
  );
};

const ContactNumberInput = ({ node, handleAnswerChange, qfusermode }) => {
  const [input, setInput] = useState(node.answer ? node.answer : null);

  const handleBlur = (event) => {
    if (node.answer != input) handleAnswerChange(input);
  };

  const handleChange = (event) => {
    setInput(event.formattedValue);
  };

  let widthFromLogic = node.logic.width
    ? `${node.logic.width}vw`
    : theme.inputStyle.width;

  return (
    <PatternFormat
      type="text"
      placeholder={"#"}
      format="(###) ###-####"
      id={"numberInput" + node.id}
      style={{ ...theme.inputStyle, width: widthFromLogic }}
      value={input}
      onValueChange={handleChange}
      onBlur={handleBlur}
      readOnly={qfusermode === INSURER ? true : false}
    ></PatternFormat>
  );
};

export default ContactNumber;
